<template>
  <Base :is-loading="dataIsLoad" :base-id="'lb-refund-detail'">
    <template #header>
      <h4 class="modal-title">退款紀錄</h4>
    </template>
    <template #body>
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th class="nowrap" scope="col">購買金額</th>
              <th class="nowrap" scope="col">購買日期</th>
              <th class="nowrap" scope="col">退款方式</th>
              <th class="nowrap" scope="col">退款狀態</th>
            </tr>
          </thead>
          <tr v-for="(refund, index) in data" :key="index">
            <td class="nowrap">
              <p>NT$ {{ refund.Amount.toLocaleString() }}</p>
            </td>
            <td class="nowrap">
              <p class="mb-0">{{ refund.Date.substring(0, 10) }}</p>
              <p class="mb-0">{{ refund.Date.substring(11) }}</p>
            </td>
            <td class="nowrap">
              <p>{{ refund.RefundWayDescription }}</p>
            </td>
            <td class="nowrap">
              <p v-if="refund.IsDone">已通知銀行</p>
              <p v-else>處理中</p>
            </td>
          </tr>
        </table>
      </div>
    </template>
  </Base>
</template>

<script setup>
import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import Base from '@global/components/common/modal/Base.vue';

import useModalStore from '@global/stores/useModalStore';
import useRefundDetail from '@global/composable/order/useRefundDetail';

const modalStore = useModalStore();
const { modalData } = storeToRefs(modalStore);

const { data, dataIsLoad, fetchAPI } = useRefundDetail({
  transactionId: modalData.value,
});

onMounted(() => {
  fetchAPI();
});
</script>
